import goToReferral from './goToReferral';

function goToReferralsIndex(status = '', query) {
  goToReferral({ status }, query);
}

export default goToReferralsIndex;
